function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { localPaginationMixin } from '@/mixins/local_pagination';
import tasks from '@/js/tasks';
import { mapState } from 'vuex';
import AddAttributeMaster from '@/apps/attributes/modules/managment/AddAttributeMaster';
import { filterMixin } from '@/mixins/filter_mixin';
import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import MigrationService from '../../services/migration_service';
import EditBlackListAttributes from '@/apps/attributes/modules/managment/EditBlackListAttributes';
import EditAttributeMaster from '@/apps/attributes/modules/managment/EditAttributeMaster';
import ConfirmDialog from '@/components/common/ConfirmDialog.vue';
export default {
  name: 'AttributeMaster',
  components: {
    AddAttributeMaster: AddAttributeMaster,
    EditBlackListAttributes: EditBlackListAttributes,
    EditAttributeMaster: EditAttributeMaster,
    ConfirmDialog: ConfirmDialog
  },
  mixins: [filterMixin, localPaginationMixin, useCaseListMixin],
  data: function data() {
    return {
      elemento: [],
      Items: [],
      BlackListItems: [],
      DIALOG_ADD: 'DIALOG_ADD',
      DIALOG_EDIT: 'DIALOG_EDIT',
      DIALOG_BLACK_LIST: 'DIALOG_BLACK_LIST',
      DIALOG_SYNC: 'DIALOG_SYNC',
      idioma: this.$i18n.locale
    };
  },
  beforeMount: function beforeMount() {
    this.getMasterAttributes();
    console.log('this.Items');
    console.log(this.Items);
  },
  methods: {
    handleConfirmSync: function handleConfirmSync(confirm) {
      var _this = this;
      if (confirm) {
        this.setShowLoading(true);
        var body = {
          "table_name": this.elemento.attribute_object_name,
          "dataset_id": this.elemento.attribute_scheme_name,
          "project_id": this.elemento.attribute_project_name,
          "resource_name": "",
          "with_vector": false,
          "call_job": false
        };
        this.$refs[this.DIALOG_SYNC].onClose();
        tasks.toast.success('Se ha iniciado la sincronización de atributos, por favor espere unos minutos para que se complete el proceso.');
        this.setShowLoading(false);
        MigrationService.scan_attributes_objects(body).then(function (response) {
          if (response && response.data) {
            _this.getMasterAttributes();
            console.log('response');
            console.log(response);
          }
        }).catch(function (error) {
          console.error('Error during synchronization:', error);
          tasks.toast.error(_this.translate('frases.error_sync_attributes'));
        });
      } else {
        this.$refs[this.DIALOG_SYNC].onClose();
      }
    },
    onSubmitAddMaster: function onSubmitAddMaster(registrar) {
      var _this2 = this;
      this.setShowLoading(true);
      UseCasesService.postAddAttributeMasterCatalog(registrar).then(function (response) {
        if (response && response.data) {
          _this2.getMasterAttributes();
          console.log('response');
          console.log(response);
          _this2.$refs[_this2.DIALOG_ADD].onClose();
          tasks.toast.success(_this2.translate('frases.successfully_registered'));
        }
      }).finally(function () {
        return _this2.setShowLoading(false);
      });
    },
    onSubmitEditMaster: function onSubmitEditMaster(actualizar) {
      var _this3 = this;
      this.setShowLoading(true);
      console.log('actualizar');
      console.log(actualizar);
      UseCasesService.patchEditAttributeMasterCatalog(actualizar, actualizar.id).then(function (response) {
        if (response && response.data) {
          _this3.getMasterAttributes();
          console.log('response');
          console.log(response);
          _this3.$refs[_this3.DIALOG_EDIT].onClose();
          tasks.toast.success(_this3.translate('frases.successfully_updated'));
        }
      }).finally(function () {
        return _this3.setShowLoading(false);
      });
    },
    create: function create() {
      console.log('create');
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    openDialogItem: function openDialogItem(item, modalName) {
      this.elemento = item;
      this.$refs[modalName].onOpen();
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
    },
    getMasterAttributes: function getMasterAttributes() {
      var _this4 = this;
      this.Items = [];
      UseCasesService.getAttributeMasterCatalog().then(function (response) {
        if (response && response.data) {
          Object.entries(response.data.attribute_source_id).forEach(function (entry) {
            var _entry = _slicedToArray(entry, 2),
              key = _entry[0],
              value = _entry[1];
            _this4.Items.push({
              id: key,
              name_es: value.name_es,
              description_es: value.description_es,
              name_en: value.name_en,
              description_en: value.description_en,
              alias: value.alias,
              attribute_scheme_name: value.attribute_scheme_name,
              attribute_project_name: value.attribute_project_name,
              attribute_object_name: value.attribute_object_name,
              attribute_group_design: value.attribute_group_design,
              denied_company_code: value.denied_company_code
            });
          });
        }
      });
    },
    cambiarIdioma: function cambiarIdioma(idioma) {
      this.idioma = idioma;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    headers: function headers() {
      return [{
        text: this.translate('attributes.group.name'),
        align: 'start',
        value: 'name'
      }, {
        text: this.translate('attributes.managment.headers.description'),
        align: 'start',
        value: 'description'
      }, {
        text: this.translate('attributes.managment.headers.table'),
        align: 'start',
        value: 'multiple'
      }, {
        text: '',
        align: 'end',
        value: 'actions'
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }),
  watch: {
    '$i18n.locale': function $i18nLocale(newLocale) {
      this.cambiarIdioma(newLocale);
    }
  }
};